import BaseInputComponent from './BaseInputComponent';
export default {
  extends: BaseInputComponent,
  props: {
    size: {
      type: String,
      default: 'sm'
    },
    variant: {
      type: String,
      default: 'default'
    }
  }
};